import type { ReactNode } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile } from '@fortawesome/pro-solid-svg-icons'

import { Box, Text } from '@domain-group/suit-theme'

import SquareIconWithBackground from '@components/SquareIconWithBackground'

import type { OrderItemModel, ServiceModel } from '@models/types'

interface BrandedOrderItemHeaderProps {
  accentColor: string,
  children?: ReactNode,
  orderItem: OrderItemModel,
  service: Partial<ServiceModel>,
}

const BrandedOrderItemHeader = (props: BrandedOrderItemHeaderProps) => {
  const {
    accentColor,
    children,
    orderItem: {
      id,
      options_string,
      title: orderItemTitle,
    },
    service: {
      title: serviceTitle,
    },
  } = props

  return (
    <Box
      backgroundColor="white"
      borderColor="lineColor"
      borderRadius={5}
      paddingLeft="large"
      paddingTop="medium"
    >
      <Box
        alignItems="center"
        backgroundColor={accentColor}
        height={28}
        justifyContent="center"
        style={{ margin: 'auto' }}
        width={28}
      >
        <SquareIconWithBackground
          backgroundColor={accentColor}
          color="white"
          height={28}
          width={28}
        >
          <Text fontSize="xsmall" color="white">
            <FontAwesomeIcon icon={faFile} />
          </Text>
        </SquareIconWithBackground>
      </Box>

      <Box padding="large" paddingLeft="medium" alignItems={['flexStart', 'center']} flexDirection={['column', 'row']}>
        <Text fontSize="small" fontWeight={600}>{serviceTitle?.toUpperCase()}</Text>

        <Text
          color="bodyFontLightColor"
          fontSize="small"
          fontWeight={400}
          marginLeft={['none', 'medium']}
          marginTop={['xsmall', 'none']}
          variant="ellipsis"
        >
          {`${orderItemTitle} ${options_string}`}
        </Text>
      </Box>

      <Box
        alignItems="flex-end"
        display={['none', 'flex']}
        flexDirection="column"
        padding="large"
        justifyContent="center"
      >
        <Text
          color="bodyFontLightColor"
          fontSize="small"
          fontWeight={400}
          variant="ellipsis"
        >{`Order Item #${id}`}
        </Text>
      </Box>

      {children}
    </Box>
  )
}

export default BrandedOrderItemHeader
